import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

declare var google: any;

@Component({
  selector: 'app-maps-detail',
  templateUrl: './maps-detail.component.html',
  styleUrls: ['./maps-detail.component.scss']
})
export class MapsDetailComponent implements OnInit {

  public entityObj: any = {};
  public errorMessage: string = '';
  public infoContent: string = '';

  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

  markerPosition: google.maps.LatLngLiteral = null;
  center: google.maps.LatLngLiteral = { lat: 40.4166400, lng: -3.7032700 };
  zoom = 6;

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.config.data.transaction) {
      this.entityObj = this.config.data.transaction;
    } else if (this.config.data.organization) {
      this.entityObj = this.config.data.organization;
    }
    this.entityObj.errorMessage = "";

    setTimeout(() => {
      this.initMarker();
    }, 10);
  }

  async initMarker() {
    if (!this.entityObj.lat || !this.entityObj.lng) {
      // Si no hay lat/lng, geocodifica la dirección
      await this.geocodePosition(this.entityObj);
    }
    // Si sigue sin lat/lng, se pone un valor por defecto
    if (!this.entityObj.lat || !this.entityObj.lng) {
      this.entityObj.lat = 40.4166400;
      this.entityObj.lng = -3.7032700;
    }
    this.markerPosition = { lat: this.entityObj.lat, lng: this.entityObj.lng };
    this.center = { lat: this.entityObj.lat, lng: this.entityObj.lng };
    this.zoom = 16;
  }

  geocodePosition(entityObj: any): Promise<void> {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: `${entityObj.address || ''} ${entityObj.postal_code || ''} ${entityObj.city || ''}` },
        (results, status) => {
          if (status === 'OK' && results[0]) {
            entityObj.lat = results[0].geometry.location.lat();
            entityObj.lng = results[0].geometry.location.lng();
            entityObj.errorMessage = '';
          } else {
            entityObj.lat = 40.4166400;
            entityObj.lng = -3.7032700;
            entityObj.errorMessage = this.translateService.instant("component.maps.cant_add_marker_in_position") +
              ` ${entityObj.address || ''} ${entityObj.postal_code || ''} ${entityObj.city || ''}`;
          }
          resolve();
        }
      );
    });
  }

  markerDragEnd(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.entityObj.lat = event.latLng.lat();
      this.entityObj.lng = event.latLng.lng();
      this.markerPosition = { lat: this.entityObj.lat, lng: this.entityObj.lng};
    }
  }

  save() {
    this.dynamicDialogRef.close(this.entityObj);
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
}
